
import {Button, message, UploadFile} from 'antd';
import { Upload } from "@formily/antd";
import { UploadOutlined, InboxOutlined } from '@ant-design/icons';


const uploadData = (info: any,props:any) =>{
   if(props.destinationPath){
      let destinationPath =props.destinationPath?props.destinationPath:`Underwriting/NonMotor/Quotations/${10}/policy_files/` ;
      let overwrite = false;
      return(`${process.env.REACT_APP_API_URL}/api/v1/dms-center/file/public/upload/link?filename=${info.name}&destinationPath=${destinationPath}&overwrite=${overwrite}`)
   }
  
 }
 
export const CardUpload = (props: any) => {
   return (
      <Upload
         {...props}
         action={(file)=>uploadData(file,props)}
         data={(info)=>{
            console.log("info",info)
           return{
             filedata:info,
           }
         }}
         listType="picture-card"
         headers={{
           authorization: 'authorization-text',
         }}
         onRemove={(info)=>{
           console.log("deleted", info.name)}}
      >
        <UploadOutlined style={{ fontSize: 20 }} />
      </Upload>
   )
 }
 export const NormalUpload = (props: any) => {
   console.log(4545,props)
   return (
      <Upload
         {...props}
         action={(file)=>uploadData(file,props)}
         data={(info)=>{
           return{
             filedata:info,
           }
         }}
         headers={{
           authorization: 'authorization-text',
         }}
      >
        <Button icon={<UploadOutlined />}>Upload files</Button>
      </Upload>
   )
 }
 
export const DragUpload = (props: any) => {
   return (
      <Upload
         {...props}
         action={(file: any)=>uploadData(file,props)}
         data={(info: UploadFile)=>{
           return{
             filedata:info,
           }
         }}
         headers={{
           authorization: 'authorization-text',
         }}
      >
        <p className="ant-upload-drag-icon">
          <InboxOutlined />
        </p>
        <p className="ant-upload-text">
          Click or drag file to this area to upload
        </p>
        <p className="ant-upload-hint">
          Support for a single or bulk upload. Strictly prohibit from uploading
          company data or other band files
        </p>
      </Upload>
   )
 }

